import * as XLSX from "sheetjs-style";
import * as FileSaver from "file-saver";

/**
 * Sunucunun rapor `sheets` çıktısından çok sayfalı .xlsx (#338, Müşteri
 * Performans). Her sayfa: { name, rows } — ilk satır başlık, "TOPLAM" ile
 * başlayan satır toplam satırı. Sayılar ham sayı kalır (Excel'de toplanabilsin).
 */

const MAX_SHEET_NAME_LENGTH = 31;
const sheetName = (name, used) => {
  let base = String(name ?? "")
    .replace(/[[\]*?/\\:]/g, " ")
    .trim()
    .slice(0, MAX_SHEET_NAME_LENGTH) || "Rapor";
  let candidate = base;
  let n = 2;
  while (used.has(candidate)) {
    const suffix = ` (${n})`;
    candidate = base.slice(0, MAX_SHEET_NAME_LENGTH - suffix.length) + suffix;
    n += 1;
  }
  used.add(candidate);
  return candidate;
};

const HEADER_STYLE = {
  font: { bold: true, color: { rgb: "FFFFFF" } },
  fill: { fgColor: { rgb: "3E2B23" } },
  alignment: { vertical: "center" },
};
const TOTAL_STYLE = { font: { bold: true }, fill: { fgColor: { rgb: "EFE6DF" } } };

/** Sayfaları çalışma kitabına çevirir (indirmeden — test edilebilsin). */
export function buildSheetsWorkbook(sheets = []) {
  const wb = XLSX.utils.book_new();
  const used = new Set();
  sheets.forEach((sheet) => {
    const rows = Array.isArray(sheet?.rows) ? sheet.rows : [];
    if (rows.length === 0) return;
    const ws = XLSX.utils.aoa_to_sheet(rows);
    const width = Math.max(...rows.map((r) => r.length));
    // Sütun genişliği içeriğe göre (en az 6, en çok 40 karakter)
    ws["!cols"] = Array.from({ length: width }, (_, c) => ({
      wch: Math.min(40, Math.max(6, ...rows.map((r) => String(r[c] ?? "").length + 2))),
    }));
    // Metin karışan sütundaki sayılar da sola — önizlemeyle aynı hiza
    for (let c = 0; c < width; c += 1) {
      const values = rows.slice(1).map((r) => r[c]).filter((v) => v !== "" && v != null);
      if (values.every((v) => typeof v === "number")) continue;
      rows.forEach((r, ri) => {
        const cell = ws[XLSX.utils.encode_cell({ r: ri, c })];
        if (ri > 0 && cell && typeof r[c] === "number") cell.s = { alignment: { horizontal: "left" } };
      });
    }
    rows.forEach((r, ri) => {
      const style =
        ri === 0 ? HEADER_STYLE : String(r[0]).toLocaleUpperCase("tr") === "TOPLAM" ? TOTAL_STYLE : null;
      if (!style) return;
      for (let c = 0; c < width; c += 1) {
        const cell = ws[XLSX.utils.encode_cell({ r: ri, c })];
        if (cell) cell.s = style;
      }
    });
    XLSX.utils.book_append_sheet(wb, ws, sheetName(sheet.name, used));
  });
  return wb;
}

export function downloadSheetsAsXlsx(sheets, fileName = "rapor") {
  if (!Array.isArray(sheets) || sheets.length === 0) return;
  const wb = buildSheetsWorkbook(sheets);
  const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const name = String(fileName || "rapor").replace(/\.xlsx$/i, "");
  FileSaver.saveAs(
    new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    }),
    `${name}.xlsx`,
  );
}
